import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { chart_lang } from "../../language/chart";

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit {
  lang = localStorage.getItem('lang') == "EN" ? "EN" : "TH";
  language: any;
  report_type = "ใบแจ้งหนี้";
  type = 1;
  showPage = false;
  isLoading = true;
  dataOfchartM;
  dataOfchartD;
  dataOfchartY;
  years = [];
  months = [
    // {value:0,name_th:'all',n},
    { value: 1, name: { TH: 'มกราคม', EN: "January" } },
    { value: 2, name: { TH: 'กุมภาพันธ์', EN: "February" } },
    { value: 3, name: { TH: 'มีนาคม', EN: "March" } },
    { value: 4, name: { TH: 'เมษายน', EN: "April" } },
    { value: 5, name: { TH: "พฤษภาคม", EN: "May" } },
    { value: 6, name: { TH: "มิถุนายน", EN: "June" } },
    { value: 7, name: { TH: "กรกฏาคม", EN: "July" } },
    { value: 8, name: { TH: "สิงหาคม", EN: "August" } },
    { value: 9, name: { TH: "กันยายน", EN: "September" } },
    { value: 10, name: { TH: "ตุลาคม", EN: "October" } },
    { value: 11, name: { TH: "พฤศจิกายน", EN: "November" } },
    { value: 12, name: { TH: "ธันวาคม", EN: "December" } }
  ];

  invoice_days = [];
  invoice_months = [];
  invoice_years = [];
  invoice_day;
  invoice_month;
  invoice_year;

  bill_days = [];
  bill_months = [];
  bill_years = [];
  bill_day;
  bill_month;
  bill_year;

  inform_days = [];
  inform_months = [];
  inform_years = [];
  inform_day;
  inform_month;
  inform_year;

  daysInmonth;
  yearInchart = new Date().getFullYear();

  functionOfchartD = '';
  functionOfchartM = '';
  functionOfchartY = '';

  month = new Date().getMonth() + 1;
  year = new Date().getFullYear();

  types = [
    { value: 1, name: { TH: 'ใบแจ้งหนี้', EN: "Invoice" } },
    { value: 2, name: { TH: 'ใบทวงหนี้', EN: "Inform" } },
    { value: 3, name: { TH: 'ใบเสร็จรับเงิน', EN: "Bill" } }
  ]

  areaChartofDay = {
    chartType: 'AreaChart',
    dataTable: [],
    options: {
      isStacked: true,
      height: 300,
      legend: { position: 'top', maxLines: 2 },
      vAxis: { minValue: 0 },
      colors: ['#5faee3', '#5faee3']
    },
  };

  areaChartofMonth = {
    chartType: 'AreaChart',
    dataTable: [],
    options: {
      isStacked: true,
      height: 300,
      legend: { position: 'top', maxLines: 2 },
      vAxis: { minValue: 0 },
      colors: ['#01C0C8', '#01C0C8']
    },
  };

  areaChartofYear = {
    chartType: 'AreaChart',
    dataTable: [],
    options: {
      isStacked: true,
      height: 300,
      legend: { position: 'top', maxLines: 2 },
      vAxis: { minValue: 0 },
      colors: ['#FB9678', '#FB9678']
    },
  };

  constructor(private service: MyserviceService, private chRef: ChangeDetectorRef, private route: ActivatedRoute, private router: Router) {
    this.language = chart_lang[this.lang];
    this.route.queryParams.subscribe(params => {
      console.log(params);
      const th = sessionStorage.getItem('flag_lang_th')
      console.log(th);
      if (params['lang'] == 'EN' && th == '1') {
        setTimeout(() => {
          this.get_data()
          sessionStorage.removeItem('flag_lang_th')

        }, 100);
      }
      if (params['lang'] == 'TH' && th == '1') {
        setTimeout(() => {
          this.get_data()
          sessionStorage.removeItem('flag_lang_th')

        }, 100);
      }

      this.lang = params['lang'];
      if (this.lang != 'th' && this.lang != 'TH') {
        this.lang = localStorage.getItem('lang') == 'EN' ? 'EN' : 'TH';

      } else {
        localStorage.setItem('lang', this.lang);

      }
    });

  }


  ngOnInit() {
    this.isLoading = true
    this.showPage = false
    const get = localStorage.getItem('dataOfchartY')
    if (!get) {
      return this.get_data()
    }
    if (this.lang == 'EN') {
      JSON.parse(localStorage.getItem('dataOfchartY'))[0][0] == 'year' ? '' : this.get_data();
    }
    if (this.lang == 'TH') {
      JSON.parse(localStorage.getItem('dataOfchartY'))[0][0] != 'year' ? '' : this.get_data();
    }
    if (parseInt(this.year.toString()) < 2500) {
      this.year = this.year + 543;
    }

    this.years = [];
    for (var i = 0; i < 5; i++) {
      this.years.push(this.year - i);
    }
    if (parseInt(localStorage.getItem('dataOfchartTypeID'), 10).toString() == 'NaN') {
      this.type = 1;
    }
    else {
      this.type = parseInt(localStorage.getItem('dataOfchartTypeID'), 10);
    }
    if (this.lang === 'TH') {
      if (this.type == 1) {
        this.report_type = "ใบแจ้งหนี้";
      } else if (this.type == 2) {
        this.report_type = "ใบทวงหนี้";
      }
      else {
        this.report_type = "ใบเสร็จรับเงิน";
      }
    } else {
      if (this.type == 1) {
        this.report_type = "Invoice";
      } else if (this.type == 2) {
        this.report_type = "Inform";
      }
      else {
        this.report_type = "Bill";
      }
    }

    if (JSON.stringify(localStorage.getItem('dataOfchartM')) == "\"undefined\"" || JSON.stringify(localStorage.getItem('dataOfchartM')) == "null") {
      this.dataOfchartM = [
        ['เดือน', this.report_type + '/ยอดรายเดือน'],
        ['มกราคม', 0],
        ['กุมภาพันธ์', 0],
        ['มีนาคม', 0],
        ['เมษายน', 0],
        ['พฤษภาคม', 0],
        ['มิถุนายน', 0],
        ['กรกฏาคม', 0],
        ['สิงหาคม', 0],
        ['กันยายน', 0],
        ['ตุลาคม', 0],
        ['พฤศจิกายน', 0],
        ['ธันวาคม', 0]
      ]

      localStorage.setItem('dataOfchartM', JSON.stringify(this.dataOfchartM));
    } else {
      this.dataOfchartM = JSON.parse(localStorage.getItem('dataOfchartM'));
    }

    if (JSON.stringify(localStorage.getItem('dataOfchartD')) == "\"undefined\"" || JSON.stringify(localStorage.getItem('dataOfchartD')) == "null") {
      this.dataOfchartD = [
        ['วันที่', this.report_type + '/ยอดรายวัน'],
        ['01', 0],
        ['02', 0],
        ['03', 0],
        ['04', 0],
        ['05', 0],
        ['06', 0],
        ['07', 0],
        ['08', 0],
        ['09', 0],
        ['10', 0],
        ['11', 0],
        ['12', 0],
        ['13', 0],
        ['14', 0],
        ['15', 0],
        ['16', 0],
        ['17', 0],
        ['18', 0],
        ['19', 0],
        ['20', 0],
        ['21', 0],
        ['22', 0],
        ['23', 0],
        ['24', 0],
        ['25', 0],
        ['26', 0],
        ['27', 0],
        ['28', 0],
        ['29', 0],
        ['30', 0],
        ['31', 0]];

      localStorage.setItem('dataOfchartD', JSON.stringify(this.dataOfchartD));
    }
    else {
      this.dataOfchartD = JSON.parse(localStorage.getItem('dataOfchartD'));
    }

    if (JSON.stringify(localStorage.getItem('dataOfchartY')) == "\"undefined\"" || JSON.stringify(localStorage.getItem('dataOfchartY')) == "null") {
      this.dataOfchartY = [
        ['ปี', this.report_type + '/ยอดรายปี'],
        ['2016', 0],
        ['2017', 0],
        ['2018', 0],
        ['2019', 0],
        ['2020', 0]
      ]

      localStorage.setItem('dataOfchartY', JSON.stringify(this.dataOfchartY));
    }
    else {
      this.dataOfchartY = JSON.parse(localStorage.getItem('dataOfchartY'));
    }

    this.areaChartofMonth = {
      chartType: 'AreaChart',
      dataTable: this.dataOfchartM,
      options: {
        isStacked: true,
        height: 300,
        legend: { position: 'top', maxLines: 2 },
        vAxis: { minValue: 0 },
        colors: ['#01C0C8', '#01C0C8']
      },
    };

    this.areaChartofDay = {
      chartType: 'AreaChart',
      dataTable: this.dataOfchartD,
      options: {
        isStacked: true,
        height: 300,
        legend: { position: 'top', maxLines: 2 },
        vAxis: { minValue: 0 },
        colors: ['#5faee3', '#5faee3']
      },
    };

    this.areaChartofYear = {
      chartType: 'AreaChart',
      dataTable: this.dataOfchartY,
      options: {
        isStacked: true,
        height: 300,
        legend: { position: 'top', maxLines: 2 },
        vAxis: { minValue: 0 },
        colors: ['#FB9678', '#FB9678']
      },
    };

    if (JSON.stringify(localStorage.getItem('dataOfchartYear')) == "\"undefined\"" || JSON.stringify(localStorage.getItem('dataOfchartYear')) == "null") {
      localStorage.setItem('dataOfchartYear', this.year.toString());
    }
    else {
      this.year = parseInt(localStorage.getItem('dataOfchartYear'));

      if (this.year < 2500) {
        this.year = this.year + 543
      }
    }

    if (JSON.stringify(localStorage.getItem('dataOfchartMonth')) == "\"undefined\"" || JSON.stringify(localStorage.getItem('dataOfchartMonth')) == "null") {
      localStorage.setItem('dataOfchartMonth', this.month.toString());
    }
    else {
      this.month = parseInt(localStorage.getItem('dataOfchartMonth'));
    }

    this.showPage = true;
    this.isLoading = false;
    this.route.queryParams.subscribe(params => {
      this.lang = params['lang'];
      if (this.lang != 'EN' && this.lang != 'TH') {
        this.lang = localStorage.getItem('lang') == 'EN' ? 'EN' : 'TH';
        this.language = chart_lang[this.lang];
      } else {
        this.language = chart_lang[this.lang];
        localStorage.setItem('lang', this.lang);
      }
    });
  }

  get_data() {
    this.showPage = false;
    this.isLoading = true;
    let year_db = 0;

    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    console.log(this.lang);

    if (this.lang === 'TH') {
      if (this.type == 1) {
        this.report_type = "ใบแจ้งหนี้";
      } else if (this.type == 2) {
        this.report_type = "ใบทวงหนี้";
      }
      else {
        this.report_type = "ใบเสร็จรับเงิน";
      }
    } else {
      if (this.type == 1) {
        this.report_type = "Invoice";
      } else if (this.type == 2) {
        this.report_type = "Inform";
      }
      else {
        this.report_type = "Bill";
      }
    }
    localStorage.setItem('dataOfchartTypeID', this.type.toString());


    if (this.type == 1) {
      this.functionOfchartD = 'chart/get-invoice-day';
      this.functionOfchartM = 'chart/get-invoice-month';
      this.functionOfchartY = 'chart/get-invoice-year';
    }
    else if (this.type == 2) {
      this.functionOfchartD = 'chart/get-inform-day';
      this.functionOfchartM = 'chart/get-inform-month';
      this.functionOfchartY = 'chart/get-inform-year';
    }
    else {
      this.functionOfchartD = 'chart/get-bill-day';
      this.functionOfchartM = 'chart/get-bill-month';
      this.functionOfchartY = 'chart/get-bill-year';
    }

    this.service.postData({ month: (this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString(), year: year_db }, this.functionOfchartD).then((result: any) => {
      if (!result.code) {
        this.invoice_days = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""));
        this.daysInmonth = new Date(parseInt(year_db.toString(), 10), parseInt(this.month.toString(), 10), 0).getDate();
        this.daysInmonth = parseInt(this.daysInmonth.toString(), 10);

        this.dataOfchartD = [];
        this.lang = localStorage.getItem('lang') == "EN" ? "EN" : "TH";
        if (this.lang === 'TH') {
          this.dataOfchartD.push(['วันที่', this.report_type + '/ยอดรายวัน']);
        }
        else {
          this.dataOfchartD.push(['date', this.report_type + '/daily amount']);
        }
        for (var i = 0; i <= this.daysInmonth - 1; i++) {
          this.invoice_day = this.invoice_days.filter((item) => {
            return item.days == (i + 1).toString().padStart(2, '0');
          })

          if (this.invoice_day.length > 0) {
            this.dataOfchartD.push([(i + 1).toString().padStart(2, '0'), parseInt(this.invoice_day[0].count, 10)]);
          }
          else {
            this.dataOfchartD.push([(i + 1).toString().padStart(2, '0'), 0]);
          }
        }

        //console.log(this.dataOfchartD);
        localStorage.setItem('dataOfchartD', JSON.stringify(this.dataOfchartD));

        //get for month
        this.service.postData({ year: year_db }, this.functionOfchartM).then((result: any) => {
          if (!result.code) {
            this.invoice_months = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""));
            this.dataOfchartM = [];
            if (this.lang === 'TH') {
              this.dataOfchartM.push(['เดือน', this.report_type + '/ยอดรายเดือน']);
            } else {
              this.dataOfchartM.push(['month', this.report_type + '/monthly amount']);

            }
            for (var i = 0; i <= 12 - 1; i++) {
              this.invoice_month = this.invoice_months.filter((item) => {
                return item.months == (i + 1).toString().padStart(2, '0');
              })

              if (this.invoice_month.length > 0) {
                if (this.lang == 'TH') {
                  switch ((i + 1).toString().padStart(2, '0')) {
                    case "01":
                      this.dataOfchartM.push(['มกราคม', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "02":
                      this.dataOfchartM.push(['กุมภาพันธ์', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "03":
                      this.dataOfchartM.push(['มีนาคม', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "04":
                      this.dataOfchartM.push(['เมษายน', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "05":
                      this.dataOfchartM.push(['พฤษภาคม', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "06":
                      this.dataOfchartM.push(['มิถุนายน', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "07":
                      this.dataOfchartM.push(['กรกฏาคม', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "08":
                      this.dataOfchartM.push(['สิงหาคม', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "09":
                      this.dataOfchartM.push(['กันยายน', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "10":
                      this.dataOfchartM.push(['ตุลาคม', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "11":
                      this.dataOfchartM.push(['พฤศจิกายน', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "12":
                      this.dataOfchartM.push(['ธันวาคม', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                  }
                }
                else {
                  switch ((i + 1).toString().padStart(2, '0')) {
                    case "01":
                      this.dataOfchartM.push(['January', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "02":
                      this.dataOfchartM.push(['February', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "03":
                      this.dataOfchartM.push(['March', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "04":
                      this.dataOfchartM.push(['April', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "05":
                      this.dataOfchartM.push(['May', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "06":
                      this.dataOfchartM.push(['June', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "07":
                      this.dataOfchartM.push(['July', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "08":
                      this.dataOfchartM.push(['August', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "09":
                      this.dataOfchartM.push(['September', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "10":
                      this.dataOfchartM.push(['October', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "11":
                      this.dataOfchartM.push(['November', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                    case "12":
                      this.dataOfchartM.push(['December', parseInt(this.invoice_month[0].count, 10)]);
                      break;
                  }
                }
              }
              else {
                if (this.lang == 'TH') {
                  switch ((i + 1).toString().padStart(2, '0')) {
                    case "01":
                      this.dataOfchartM.push(['มกราคม', 0]);
                      break;
                    case "02":
                      this.dataOfchartM.push(['กุมภาพันธ์', 0]);
                      break;
                    case "03":
                      this.dataOfchartM.push(['มีนาคม', 0]);
                      break;
                    case "04":
                      this.dataOfchartM.push(['เมษายน', 0]);
                      break;
                    case "05":
                      this.dataOfchartM.push(['พฤษภาคม', 0]);
                      break;
                    case "06":
                      this.dataOfchartM.push(['มิถุนายน', 0]);
                      break;
                    case "07":
                      this.dataOfchartM.push(['กรกฏาคม', 0]);
                      break;
                    case "08":
                      this.dataOfchartM.push(['สิงหาคม', 0]);
                      break;
                    case "09":
                      this.dataOfchartM.push(['กันยายน', 0]);
                      break;
                    case "10":
                      this.dataOfchartM.push(['ตุลาคม', 0]);
                      break;
                    case "11":
                      this.dataOfchartM.push(['พฤศจิกายน', 0]);
                      break;
                    case "12":
                      this.dataOfchartM.push(['ธันวาคม', 0]);
                      break;
                  }
                }
                else {
                  switch ((i + 1).toString().padStart(2, '0')) {
                    case "01":
                      this.dataOfchartM.push(['January', 0]);
                      break;
                    case "02":
                      this.dataOfchartM.push(['February', 0]);
                      break;
                    case "03":
                      this.dataOfchartM.push(['March', 0]);
                      break;
                    case "04":
                      this.dataOfchartM.push(['April', 0]);
                      break;
                    case "05":
                      this.dataOfchartM.push(['May', 0]);
                      break;
                    case "06":
                      this.dataOfchartM.push(['June', 0]);
                      break;
                    case "07":
                      this.dataOfchartM.push(['July', 0]);
                      break;
                    case "08":
                      this.dataOfchartM.push(['August', 0]);
                      break;
                    case "09":
                      this.dataOfchartM.push(['September', 0]);
                      break;
                    case "10":
                      this.dataOfchartM.push(['October', 0]);
                      break;
                    case "11":
                      this.dataOfchartM.push(['November', 0]);
                      break;
                    case "12":
                      this.dataOfchartM.push(['December', 0]);
                      break;
                  }
                }
              }
            }

            //console.log(this.dataOfchartM);
            localStorage.setItem('dataOfchartM', JSON.stringify(this.dataOfchartM));

            //get for year
            this.service.postData({}, this.functionOfchartY).then((result: any) => {
              if (!result.code) {
                this.invoice_years = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""));
                this.dataOfchartY = [];
                if (this.lang === 'TH') {
                  this.dataOfchartY.push(['ปี', this.report_type + '/ยอดรายปี'],);
                } else {
                  this.dataOfchartY.push(['year', this.report_type + '/annual balance'],);
                }
                console.log(this.yearInchart);
                console.log(this.invoice_years);
                for (var i = 0; i <= 5 - 1; i++) {
                  this.invoice_year = this.invoice_years.filter((item) => {
                    return item.years == (parseInt(this.yearInchart.toString(), 10) - i).toString();
                  })

                  console.log(this.invoice_year);
                  if (this.invoice_year.length > 0) {
                    this.dataOfchartY.push([(parseInt((this.yearInchart + 543).toString(), 10) - i).toString(), parseInt(this.invoice_year[0].count, 10)]);
                    console.log((parseInt((this.yearInchart + 543).toString(), 10) - i).toString(), parseInt(this.invoice_year[0].count, 10));
                  }
                  else {
                    this.dataOfchartY.push([(parseInt((this.yearInchart + 543).toString(), 10) - i).toString(), 0]);
                    console.log((parseInt((this.yearInchart + 543).toString(), 10) - i).toString(), 0);
                  }
                }

                //console.log(this.dataOfchartY);
                localStorage.setItem('dataOfchartY', JSON.stringify(this.dataOfchartY));
                localStorage.setItem('dataOfchartYear', year_db.toString());
                localStorage.setItem('dataOfchartMonth', this.month.toString());
                this.showPage = true;
                window.location.reload();
              }
              else {
                localStorage.setItem('dataOfchartY', undefined);
                this.showPage = true;
                window.location.reload();
              }
            });
          }
          else {
            localStorage.setItem('dataOfchartM', undefined);
            this.showPage = true;
            window.location.reload();
          }
        });
      }
      else {
        localStorage.setItem('dataOfchartD', undefined);
        localStorage.setItem('dataOfchartM', undefined);
        localStorage.setItem('dataOfchartY', undefined);
        this.showPage = true;
        window.location.reload();
      }
    })
  }

}
